import {combineReducers} from 'redux'
import usuario from './usuarioReducer'

const Reducers = combineReducers({
    usuario
})

export default Reducers 